import { ActionContext } from 'vuex';
import store from '..';

const storeState: {
  errors: Record<string, string[]>,
  showModal: boolean,
} = {
  errors: {},
  showModal: false,
};

export default {
  namespaced: true,

  state: storeState,

  getters: {
    errors: (state: typeof storeState) => Object
      .keys(state.errors)
      .filter((key) => state.errors[key].length > 0)
      .reduce((acc, cur) => ({ ...acc, [cur]: state.errors[cur] }), {}),

    showModal: (state: typeof storeState) => state.showModal,
  },

  mutations: {
    setErrors: (state: typeof storeState, payload: Record<string, string[]>) => {
      state.errors = payload;
    },

    setModalState: (state: typeof storeState, payload: boolean) => {
      state.showModal = payload;
    },
  },

  actions: {
    showSummary: (
      ctx: ActionContext<typeof storeState, typeof store['state']>,
      payload: Record<string, string[]>,
    ) => {
      ctx.commit('setErrors', payload);

      if (Object.keys(payload).length) {
        ctx.commit('setModalState', true);
      }
    },

    dismissSummary: (
      ctx: ActionContext<typeof storeState, typeof store['state']>,
      payload?: {},
    ) => {
      ctx.commit('setErrors', []);
      ctx.commit('setModalState', false);
    },
  },
};
